import type { ComponentFactory } from '@wix/wix-ui-test-utils/driver-factory';
import { tooltipLegacyDriverFactory } from '../Tooltip/Tooltip.driver';
import { linearProgressBarDriverFactory as coreLinearProgressBarDriverFactory } from './LinearProgressBarCore/LinearProgressBarCore.driver';
import { dataHooks } from './LinearProgressBar.constants';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

const linearProgressBarDriverFactory = ({
  element,
  eventTrigger,
  wrapper,
}: ComponentFactory) => {
  deprecationTestkitLog(
    'linearProgressBarTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the LinearProgressBarTestkit unidriver testkit instead.',
  );

  const getElementByDataHook = (dataHook: string) =>
    element?.querySelector(`[data-hook='${dataHook}']`) || undefined;
  const createTooltipDriver = () =>
    tooltipLegacyDriverFactory({
      element: getElementByDataHook(dataHooks.tooltip),
      eventTrigger,
    });

  const coreProgressBarDriver = coreLinearProgressBarDriverFactory({
    element,
    wrapper,
    eventTrigger,
  });

  return {
    ...coreProgressBarDriver,
    isErrorIconShown: () => !!getElementByDataHook(dataHooks.errorIcon),
    isSuccessIconShown: () => !!getElementByDataHook(dataHooks.successIcon),
    getTooltipErrorMessage: () => {
      const tooltipDriver = createTooltipDriver();
      return tooltipDriver.getTooltipText();
    },
    getSkin: () => element?.getAttribute('data-skin'),
    getPadding: () => element?.getAttribute('data-padding'),
  };
};

export type LinearProgressBarDriver = ReturnType<
  typeof linearProgressBarDriverFactory
>;

export default linearProgressBarDriverFactory;
